import api from "../api";

export async function fetchVendorAccess() {
  try {
    const res = await api.get("/vendor/me");
    return {
      isVendor: Boolean(res.data?.vendor_user),
      vendorUser: res.data?.vendor_user || null,
      partner: res.data?.partner || null,
    };
  } catch {
    return {
      isVendor: false,
      vendorUser: null,
      partner: null,
    };
  }
}
